import { render } from "./index.vue?vue&type=template&id=ff49db80&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=ff49db80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff49db80"

export default script